import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import { preventDefault, testAttr } from '../../helpers';
import styles from './Link.styles';
const isRenderFn = (value) => typeof value === 'function';
export const Link = ({ className, 
// eslint-disable-next-line no-script-url
href = 'javascript:;', fullWidth = false, active = false, disabled = false, underline = false, color, target, onClick, children, classes, testId, }) => {
    if (isRenderFn(children)) {
        return children({
            className: cn(classes.root, fullWidth && classes.fullWidth, underline && classes.underline, className),
            activeClassName: classes.active,
        });
    }
    return (_jsx("a", Object.assign({ className: cn(classes.root, fullWidth && classes.fullWidth, active && classes.active, disabled && classes.disabled, underline && classes.underline, className), href: href, target: target, onClick: disabled
            ? preventDefault()
            : onClick &&
                preventDefault(onClick), style: { color } }, testAttr(testId), { children: children })));
};
export default withStyles(styles)(Link);
//# sourceMappingURL=Link.js.map